<app-password-form-card heading="Registration" class="password-form_wrapper" (formObj)="onFormSubmit($event)" [style.background-image]="isDesktopLayout ? 'url(' + headerImage + ')' : ''"
  (formState)="state($event)">
</app-password-form-card>